// 🩺 환자앱 「첫 방문 등록」 — 치과 웹 공통 상수 (2026-09-30, 계약 docs/계약_첫방문등록_서버_2026-09-30.md)
// 문구 출처: docs/동의정본_첫방문등록_intake_2026-09-30.md §10 화면 문구표 (그대로 사용)
// 공통 5항목 라벨 (계약 §1-1 common — 이름·생년월일·연락처·주소·내원 이유. 주민등록번호 필드 없음)
export const INTAKE_COMMON_FIELDS = [
    { key: 'name', label: '이름' },
    { key: 'birthDate', label: '생년월일' },
    { key: 'phone', label: '연락처' },
    { key: 'address', label: '주소' },
    { key: 'visitReason', label: '내원 이유' },
];

// 선택 5종 (계약 §1-2 intakeFields 키 고정 — 자유 질문 없음). 라벨은 정본 §10-2
export const INTAKE_OPTIONAL_FIELDS = [
    { key: 'history', label: '병력' },
    { key: 'meds', label: '복용 중인 약' },
    { key: 'allergy', label: '알레르기' },
    { key: 'pregnancy', label: '임신 여부' },
    { key: 'priorTreatment', label: '이전 치료' },
];

export const INTAKE_OPTIONAL_KEYS = INTAKE_OPTIONAL_FIELDS.map(f => f.key);

// 정본 §10-1 카드 1줄 고정 문구
export const INTAKE_NOTICE = '이 내용은 진료기록부가 아닙니다. 차트에 옮겨 적은 뒤 [옮겨 적음]을 눌러 주세요.';

// 정본 §10-1 확인 모달
export const INTAKE_CONFIRM_TEXT = '차트에 옮겨 적었습니까? 표시하면 7일 뒤 전달본이 삭제되고 이 화면에서 다시 볼 수 없습니다.';

// 계약 §4 오류표 → 화면 문구. 환자 이름·내용은 절대 포함하지 않는다.
export function intakeErrorMessage(e, fallback) {
    const code = String(e?.code || '').replace(/^functions\//, '');
    const detail = e?.details?.code;
    if (detail === 'feature-off') return '첫 방문 등록 기능이 아직 열리지 않았습니다.';
    if (code === 'unauthenticated') return '로그인이 필요합니다. 다시 로그인해 주세요.';
    if (code === 'permission-denied') return '치과 계정만 사용할 수 있습니다. 승인 대기 중이면 승인 후 이용해 주세요.';
    if (code === 'not-found') return '전달본이 없습니다. 환자가 취소했거나 보관 기간이 지나 삭제된 건입니다.';
    if (code === 'failed-precondition') return '지금은 처리할 수 없는 상태입니다. 화면을 새로 고친 뒤 다시 시도해 주세요.';
    if (code === 'resource-exhausted') return '요청이 많아 잠시 제한되었습니다. 잠시 후 다시 시도해 주세요.';
    if (code === 'internal' || code === 'unavailable' || code === 'deadline-exceeded') return '서버 처리에 실패했습니다. 잠시 후 다시 시도해 주세요.';
    return fallback || '처리하지 못했습니다. 잠시 후 다시 시도해 주세요.';
}

// E.164(+8210…) → 010-0000-0000 표시용. 실패 시 원문
export function formatIntakePhone(p) {
    const s = String(p || '');
    const m = s.match(/^\+82(\d{2})(\d{3,4})(\d{4})$/);
    if (m) return `0${m[1]}-${m[2]}-${m[3]}`;
    return s;
}

// ms → 'YYYY.M.D HH:mm'
export function formatIntakeTime(ms) {
    if (!ms) return '';
    const d = new Date(ms);
    if (isNaN(d)) return '';
    return `${d.getFullYear()}.${d.getMonth() + 1}.${d.getDate()} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}
